import React from 'react';
import './App.css';
import LoginPage from './pages/loginPage';
import CoursePage from './pages/coursePage';
import MyCoursePage from './pages/MyCoursePage';
import ProfilePage from './pages/ProfilePage';
import EditProfilePage from './pages/EditProfilePage';
import SurveyPage from './pages/Survey.jsx';
import TestPage from './pages/TestPage'; 
import ResetPasswordPage from './pages/ResetPassword'; 
import CalendarPage from './pages/CalendarPage.jsx'; 
import AllComment from './pages/AllComment.jsx';
import DowloadFile from './pages/DowloadFile.jsx';

import Topbar from './components/Topbar.jsx';
import Footer from './components/Footer.jsx';  // เพิ่มการนำเข้า Footer
import { useEffect } from 'react'; 


import Modal from 'react-modal';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

function App() {
  const HOMEPAGE = process.env.REACT_APP_HOMEPAGE;
  const IS_DEV = parseInt(process.env.REACT_APP_IS_DEV);
  Modal.setAppElement('#root');
  
  var basename = IS_DEV ? '/' : HOMEPAGE;

  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column'}}>
      <Router basename={basename}>
        <TopbarDisplay />
        <ScrollToTop/>
        <main style={{ flex: 1 ,minHeight: '100vh', }}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/ResetPassword" element={<ResetPasswordPage />} />
            <Route path="/main" element={<CalendarPage />} />
            <Route path="/course" element={<CoursePage />} />
            <Route path="/complete-couse" element={<MyCoursePage />} />
            <Route path="/Profile" element={<ProfilePage />} />
            <Route path="/editprofile" element={<EditProfilePage />} />
            <Route path="/survey" element={<SurveyPage />} />
            <Route path="/Test" element={<TestPage />} />
            <Route path="/community-comment" element={<AllComment />} />
            <Route path="/dowload-files" element={<DowloadFile />} />
          </Routes>
        </main>
        {/* <Footer /> */}
      </Router>
    </div>
  );
}

function TopbarDisplay() {
  const location = useLocation();

  // ตรวจสอบว่าเป็นหน้า ResetPassword และมี verifyToken อยู่ใน query string
  const isResetPasswordWithToken = 
    location.pathname.includes('/ResetPassword') && 
    new URLSearchParams(location.search).has('verifyToken');

  return !(
    location.pathname === '/' ||
    location.pathname === '/login' ||
    isResetPasswordWithToken
  ) ? (
    <Topbar />
  ) : null;
}


function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // เลื่อนหน้าไปที่ด้านบนสุด
  }, [location]);

  return null;
}

export default App;
